var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUserPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 28,
    viewBox: "0 0 20 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.33332 3.33366V24.667H16.6667V3.33366H3.33332ZM1.99999 0.666992H18C18.7364 0.666992 19.3333 1.26395 19.3333 2.00033V26.0003C19.3333 26.7367 18.7364 27.3337 18 27.3337H1.99999C1.26362 27.3337 0.666656 26.7367 0.666656 26.0003V2.00033C0.666656 1.26395 1.26362 0.666992 1.99999 0.666992ZM9.99999 20.667C10.7364 20.667 11.3333 21.2639 11.3333 22.0003C11.3333 22.7367 10.7364 23.3337 9.99999 23.3337C9.26359 23.3337 8.66666 22.7367 8.66666 22.0003C8.66666 21.2639 9.26359 20.667 9.99999 20.667Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserPhone);
export default __webpack_public_path__ + "static/media/user-phone.d1a9f1b83b37d6fd3288ac92becca64b.svg";
export { ForwardRef as ReactComponent };